import { Div, Icon, Label, Touchable, useWindowSize } from "@grassrootly/rn-core";
import moment from "moment";
import { PlayerRating, PlayerWinner } from "../../shared";
import { GamesListItemProps } from "./GamesList.types";
import { isInStatus, isScheduledOrConfirmed } from "../lib";
import { GameStatues } from "@grassrootly/api";
import { Image, View } from "react-native";
import { images } from "../../../layout/assets";

const TeamLogo = ({ character, isTablet }: { character: string; isTablet: boolean }) => {
  return (
    <Div
      classNames={[
        "p-{2}",
        "bgSecondaryMain",
        "borderPrimary",
        "bw-{1}",
        `${!isTablet ? "h-{30}" : "h-{20}"}`,
        `${!isTablet ? "w-{30}" : "w-{20}"}`,
        "br-{30}",
        "alignItemsCenter",
        "justifyContentCenter",
      ]}
    >
      <Label numberOfLines={1} type={!isTablet ? "l1Regular" : "l4Regular"}>
        {character}
      </Label>
    </Div>
  );
};

const PlayerStayedHome = () => {
  return (
    <Div
      classNames={[
        "p-{2}",
        "bgSecondaryMain",
        "borderPrimary",
        "bw-{1}",
        "h-{30}",
        "w-{30}",
        "br-{30}",
        "alignItemsCenter",
        "justifyContentCenter",
      ]}
    >
      <Icon name="home" size={15} classNames={["colorSecondaryLight"]} />
    </Div>
  );
};

export function GamesListItem({ game, showGroupName, onGamePress }: GamesListItemProps) {
  const { isTablet } = useWindowSize();
  const isGameFinished = isInStatus(game, GameStatues.FINISHED);
  const isGameFinalized = isInStatus(game, GameStatues.FINALIZED);
  const hasPlayerAttended = () => game.player_attended !== false && game.player_attended !== null;

  return (
    <Touchable
      classNames={[
        `${!isTablet ? "p16" : "pv16"}`,
        "borderBottomSolid",
        "borderSolid",
        "borderSecondary",
        "bwBottom-{1}",
      ]}
      onPress={() => onGamePress && onGamePress(game.game_id)}
    >
      <Div>
        {/* Organization/Group info */}
        <Div classNames={["flexRow", "alignItemsCenter", "gap8", "flexWrap"]}>
          {game.game_type === 'TRAINING' && !game.organization_logo && !game.season_summary && game.group_name ? (
            <Div classNames={["flexRow", "alignItemsCenter", "gap8", "mb-{8}"]}>
              {game.group_logo && (
                <Image
                  source={{ uri: game.group_logo }}
                  style={{ height: !isTablet ? 20 : 16, width: !isTablet ? 20 : 16, borderRadius: 4 }}
                  resizeMode="cover"
                />
              )}
              <Div classNames={["bgSecondaryMain", "rounded", "alignSelfFlexStart"]}>
                <Label classNames={[!isTablet ? "ph16" : "ph8", "pv2"]} type={!isTablet ? "l2Regular" : "l4Regular"}>
                  {game.group_name}
                </Label>
              </Div>
              <Div classNames={["bgSecondaryLight", "rounded"]}>
                <Label classNames={["ph8", "pv2"]} type="l4Regular">
                  Training
                </Label>
              </Div>
            </Div>
          ) : game.game_type === 'TRAINING' ? (
            <Div classNames={["flexRow", "alignItemsCenter", "gap8", "mb-{8}"]}>
              {game.organization_logo && (
                <Image
                  source={{ uri: game.organization_logo }}
                  style={{ height: !isTablet ? 20 : 16, width: !isTablet ? 20 : 16, borderRadius: 4 }}
                  resizeMode="cover"
                />
              )}
              {game.season_summary && (
                <Div classNames={["bgSecondaryMain", "rounded", "alignSelfFlexStart"]}>
                  <Label classNames={[!isTablet ? "ph16" : "ph8", "pv2"]} type={!isTablet ? "l2Regular" : "l4Regular"}>
                    {game.season_summary}
                  </Label>
                </Div>
              )}
              <Div classNames={["bgSecondaryLight", "rounded"]}>
                <Label classNames={["ph8", "pv2"]} type="l4Regular">
                  Training
                </Label>
              </Div>
            </Div>
          ) : (
            <Div classNames={["flexRow", "alignItemsCenter", "gap8", "mb-{8}"]}>
              {game.organization_logo && (
                <Image
                  source={{ uri: game.organization_logo }}
                  style={{ height: !isTablet ? 20 : 16, width: !isTablet ? 20 : 16, borderRadius: 4 }}
                  resizeMode="cover"
                />
              )}
              {game.season_summary && (
                <Div classNames={["bgSecondaryMain", "rounded", "alignSelfFlexStart"]}>
                  <Label classNames={[!isTablet ? "ph16" : "ph8", "pv2"]} type={!isTablet ? "l2Regular" : "l4Regular"}>
                    {game.season_summary}
                  </Label>
                </Div>
              )}
            </Div>
          )}
        </Div>

        <Div classNames={["flexRow", "alignItemsCenter"]}>
          {/* Game Date column */}
          <Div classNames={["alignItemsFlexStart", "w-{20%}"]}>
            <Div classNames={["bgPrimaryWashed", "p8", "rounded", "alignItemsCenter"]}>
              <Label numberOfLines={1} type={!isTablet ? "l3Regular" : "l4Regular"}>
                {moment(game.game_datetime).format("DD.MM.YY")}
              </Label>
            </Div>
            {isInStatus(game, GameStatues.CANCELED) && (
              <Div classNames={["mt-{3}", "ml-{3}"]}>
                <Label type={"l4Regular"} classNames={["colorDangerMain"]}>
                  {game.game_status}
                </Label>
              </Div>
            )}
          </Div>

          {/* Teams column */}
          <Div classNames={["w-{30%}"]}>
            <Div classNames={["gap8", "flexRow", "mb-{5}"]}>
              {/* <TeamLogo character={'B'} isTablet={isTablet}></TeamLogo> */}
              <Image
                style={{ height: 20, width: 20, borderRadius: 40 }}
                resizeMode="cover"
                source={game.host_team_logo ? { uri: game.host_team_logo } : images.whiteTeamLogo}
              />
              <Label numberOfLines={2} ellipsizeMode="tail" type={!isTablet ? "l2Regular" : "l3Regular"}>
                {game.game_host_team_name || "Beli"}
              </Label>
            </Div>
            <Div classNames={["gap8", "flexRow"]}>
              {/* <TeamLogo character={'M'} isTablet={isTablet}></TeamLogo> */}
              <Image
                style={{ height: 20, width: 20, borderRadius: 40 }}
                resizeMode="cover"
                source={game.visitor_team_logo ? { uri: game.visitor_team_logo } : images.blackTeamLogo}
              />
              <Label numberOfLines={2} ellipsizeMode="tail" type={!isTablet ? "l2Regular" : "l3Regular"}>
                {game.game_visitor_team_name || "Markeri"}
              </Label>
            </Div>
          </Div>

          {/* Player stats column */}
          <Div classNames={["w-{30%}", "alignItemsFlexEnd"]}>
            {hasPlayerAttended() && (isGameFinished || isGameFinalized) && (
              <Div classNames={["flexRow", "alignItemsCenter", "flexWrap", "gap4"]}>
                {!!game.player_goals_scored && (
                  <Div classNames={["flexRow", "alignItemsCenter"]}>
                    <Icon name="sports_soccer" classNames={game.player_goals_scored > 1 ? ["mr-{2}"] : []} size={16} />
                    {game.player_goals_scored > 1 && <Label type={"l4Regular"}>x{game.player_goals_scored}</Label>}
                  </Div>
                )}
                {!!game.player_assists_made && (
                  <Div classNames={["flexRow", "alignItemsCenter"]}>
                    <Image source={images.assist} style={{ height: 12, width: 20, marginRight: game.player_assists_made > 1 ? 2 : 0 }} />
                    {game.player_assists_made > 1 && <Label type={"l4Regular"}>x{game.player_assists_made}</Label>}
                  </Div>
                )}
                {!!game.player_own_goals && (
                  <Div classNames={["flexRow", "alignItemsCenter"]}>
                    <Icon name="sports_soccer" color="#DC2626" classNames={game.player_own_goals > 1 ? ["mr-{2}"] : []} size={16} />
                    {game.player_own_goals > 1 && <Label type={"l4Regular"}>x{game.player_own_goals}</Label>}
                  </Div>
                )}
                {!!game.player_yellow_cards && (
                  <Div classNames={["flexRow", "alignItemsCenter"]}>
                    <View style={{ width: 8, height: 12, backgroundColor: '#FFC107', borderRadius: 2, marginRight: game.player_yellow_cards > 1 ? 2 : 0 }} />
                    {game.player_yellow_cards > 1 && <Label type={"l4Regular"}>x{game.player_yellow_cards}</Label>}
                  </Div>
                )}
                {!!game.player_red_cards && (
                  <Div classNames={["flexRow", "alignItemsCenter"]}>
                    <View style={{ width: 8, height: 12, backgroundColor: '#DC2626', borderRadius: 2, marginRight: game.player_red_cards > 1 ? 2 : 0 }} />
                    {game.player_red_cards > 1 && <Label type={"l4Regular"}>x{game.player_red_cards}</Label>}
                  </Div>
                )}
                {!!game.player_errors_leading_to_a_goal && (
                  <Div classNames={["flexRow", "alignItemsCenter"]}>
                    <Icon name="fmd_bad" color="#DC2626" classNames={game.player_errors_leading_to_a_goal > 1 ? ["mr-{2}"] : []} size={16} />
                    {game.player_errors_leading_to_a_goal > 1 && <Label type={"l4Regular"}>x{game.player_errors_leading_to_a_goal}</Label>}
                  </Div>
                )}
                {!!game.player_saves && (
                  <Div classNames={["flexRow", "alignItemsCenter"]}>
                    <Icon name="front_hand" classNames={game.player_saves > 1 ? ["mr-{2}"] : []} size={16} />
                    {game.player_saves > 1 && <Label type={"l4Regular"}>x{game.player_saves}</Label>}
                  </Div>
                )}
                {!!game.player_outcome && (
                  <Div classNames={["flexRow"]}>
                    <PlayerWinner outcome={game.player_outcome} playerAttended={true} />
                  </Div>
                )}
              </Div>
            )}
          </Div>

          {/* Game score column */}
          <Div classNames={["gap8", "alignItemsCenter", "w-{10%}"]}>
            {(isGameFinished || isGameFinalized) && (!isScheduledOrConfirmed(game) || !isGameFinished) && (
              <>
                <Div classNames={["alignItemsCenter", "gap8"]}>
                  {game.game_host_score != null && (
                    <Label numberOfLines={1} type={!isTablet ? "l1Bold" : "l3Bold"}>
                      {game.game_host_score}
                    </Label>
                  )}
                </Div>
                <Div classNames={["alignItemsCenter", "gap8"]}>
                  {game.game_visitor_score != null && (
                    <Label numberOfLines={1} type={!isTablet ? "l1Bold" : "l3Bold"}>
                      {game.game_visitor_score}
                    </Label>
                  )}
                </Div>
              </>
            )}
          </Div>

          {/* Player rating column */}
          <Div classNames={["w-{10%}", "alignItemsFlexEnd"]}>
            {hasPlayerAttended() && isGameFinalized ? (
              <Div>
                {typeof game.player_rating === "number" && (
                  <PlayerRating rating={game.player_rating} classNames={[!isTablet ? "p-{8}" : "p-{4}"]} />
                )}
              </Div>
            ) : (
              (isGameFinished || isGameFinalized) && !hasPlayerAttended() && <PlayerStayedHome />
            )}
          </Div>
        </Div>
      </Div>
    </Touchable>
  );
}
